<!--
CREATE TABLE `pos_posdevice_app` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `pos_id` int(11) DEFAULT NULL COMMENT 'POS机',
  `app_name` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '应用名称',
  `package_name` varchar(100) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '包名',
  `activity_name` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '入口',
  `icon` longtext COLLATE utf8mb4_bin COMMENT '图标',
  `create_time` datetime DEFAULT NULL,
  `update_time` datetime DEFAULT NULL,
  PRIMARY KEY (`id`),
  KEY `pos_id` (`pos_id`),
  KEY `app_name` (`app_name`)
) ENGINE=InnoDB AUTO_INCREMENT=21 DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_bin;
-->
<template>
  <div class="main-body">
    <!-- 查询区域 -->
    <div class="search-box">
      <el-input v-model="query.app_name" placeholder="应用名称" size="mini" style="width:200px" />
      <el-input v-model="query.pos_id" placeholder="POS机ID" size="mini" style="width:150px" />
      <el-button type="primary" @click="getList" size="mini">搜索</el-button>
    </div>

    <!-- 表格 -->
    <el-table :data="pageData.list" border height="70vh">
      <el-table-column prop="id" label="ID" width="70" fixed />
      <el-table-column prop="pos_id" label="POS机ID" width="90" />
      <el-table-column prop="app_name" label="应用名称" width="150" show-overflow-tooltip />
      <el-table-column prop="package_name" label="包名" min-width="200" show-overflow-tooltip />
      <el-table-column prop="activity_name" label="入口" min-width="150" show-overflow-tooltip />
      <el-table-column prop="icon" label="图标" width="80">
        <template slot-scope="scope">
          <img v-if="scope.row.icon" :src="'data:image/png;base64,'+scope.row.icon" style="width:30px;height:30px;border-radius:4px" />
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="150" />
      <el-table-column prop="update_time" label="修改时间" width="150" />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="pageData.page"
      :page-size="pageData.size"
      layout="total, prev, pager, next,sizes"
      :total="pageData.total"
      :page-sizes="[10, 20, 50, 100]"
      style="margin-top:15px;text-align:right"
    />
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'

export default {
  name: 'PosDeviceApp',
  data() {
    return {
      query: {
        app_name: "",
        pos_id: "",
      },
      pageData: {
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
      dialogVisible: false,
      form: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      const params = Params.ins()
        .where(this.query.app_name ? ['app_name', 'like', '%' + this.query.app_name + '%'] : null)
        .where(this.query.pos_id ? ['pos_id', '=', this.query.pos_id] : null)
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('PosDeviceApp/index', params, res => {
        if (res.code === 200) {
          this.pageData = res.data
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },
    sizeChange(size) {
      this.pageData.size = size
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.main-body {
  padding: 15px;

  .search-box {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/PosDevice/PosDeviceApp.vue